import styled from "styled-components";

export const CardContainer = styled.div`
  position: relative;
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  display: flex;
  flex-direction: ${({ isOneColumn }) => (isOneColumn ? "row" : "column")};
  overflow: hidden;
  height: 100%;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: url(${({ imageUrl }) => imageUrl});
    background-position: center;
    background-size: cover;
    filter: blur(30px);
  }
`;

export const CardCoverContainer = styled.div`
  padding: 3px;
  z-index: 1;
`;

export const CardCover = styled.div`
  background: ${({ imageUrl }) => `url(${imageUrl})`};
  background-size: cover;
  background-position: ${({ position }) =>
    position ? `${position.x}% ${position.y}%` : "center"};
  border-radius: ${({ borderRadius }) => `${borderRadius - 3}px`};

  ${({ isOneColumn }) =>
    isOneColumn
      ? `
      width: 269px;
      height: 233px;
      `
      : `
      height: 170px;
  `}
`;

export const CardContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  z-index: 1;
  height: 100%;
  box-sizing: border-box;
  justify-content: ${({ isOneColumn }) =>
    isOneColumn ? "space-around" : "space-between"};
  padding: ${({ isOneColumn }) => (isOneColumn ? "24px 40px" : "12px 14px")};
  flex: ${({ isOneColumn }) => (isOneColumn ? 1 : "0 1 auto")};
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ isOneColumn }) => (isOneColumn ? "0px" : "10px")};
`;

export const CardHeading = styled.h1`
  margin: 0;
  font-size: ${({ isOneColumn }) => (isOneColumn ? "32px" : "22px")};
  color: #ffffff;
  font-weight: ${({ isOneColumn }) => (isOneColumn ? 600 : 500)};
  max-width: 80%;
`;

export const CardParagraph = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.6);
  width: 80%;
  white-space: pre-wrap;
`;

export const CardLabel = styled.span`
  padding: 5px 10px;
  font-size: 12px;
  color: ${({ color }) => color};
  background: ${({ background }) => background};
  border-radius: 9999px;
  width: fit-content;
  height: 26px;
  box-sizing: border-box;
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: ${({ hasLabel }) => (hasLabel ? "space-between" : "end")};
  align-items: center;
`;

export const CardArrowContainer = styled.div`
  opacity: 0.5;

  ${({ isAbsolute }) =>
    isAbsolute &&
    `
    position: absolute;
    bottom: 10px;
    right: 10px;
  `}
`;
